import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconArrowDropUpSvg } from "./IconArrowDropUpSvg.mjs";
const IconArrowDropUp = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconArrowDropUpSvg, ...iconProps });
};
export {
  IconArrowDropUp
};
